import { Dispatch, SetStateAction } from 'react';

export const bulkActionHandler = (
  setIds: Dispatch<SetStateAction<number[]>>
): ((actionType: unknown, identifiersArr: number[]) => void) => {
  return (actionType: unknown, identifiersArr: number[]) => {
    if (actionType === 'delete') {
      setIds(identifiersArr);
    }
  };
};
